import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { School } from '../dropdown-school/org.school';
import { PostBaselineProgress } from '../graphs/post-baseline-progress';
import { OrgService } from '../_services/org.service';
import { ReportService } from '../_services/report-service';
import { PhaseService } from '../_services/phase.service';
import { LoaderService } from '../loader/loader.service';

@Component({
	selector: 'progress-bar-school',
	templateUrl: './progress-bar-school.component.html',
})
export class ProgressBarSchoolComponent implements OnInit {
	subscriptions: Subscription[] = [];
	selectedSchool: School;
	graphData: PostBaselineProgress;
	constructor(
		private orgService: OrgService,
		private reportService: ReportService,
		private phaseService: PhaseService,
		public LoaderService: LoaderService,
	) {}

	ngOnInit(): void {
		this.subscriptions.push(
			this.orgService.selectedSchool$.subscribe((data: School) => {
				//any school data change will get graph data.
				this.selectedSchool = data;
			}),
		);

		this.subscriptions.push(
			this.phaseService.selectedPhase$.subscribe((phase: any) => {
				if (this.selectedSchool) {
					this.getGraphDataSchool(phase);
				}
			}),
		);
		this.subscriptions.push(
			this.reportService.postBaselineProgressSchool.subscribe(
				(graphData: PostBaselineProgress) => {
					//any graph data change will cause a redraw.
					this.graphData = graphData;
				},
			),
		);
	}

	private getGraphDataSchool(phase: any) {
		this.reportService
			.getProgAfterBaseline(
				this.selectedSchool.id,
				phase.assessmentBookId,
				phase.assessmentTemplateId,
			)
			.subscribe(
				(data) => {
					//init graph data from db.
					this.reportService.setgrogressAfterBaselineSchool(data);
				},
				(error) => {
					console.log(error);
				},
			);
	}

	ngOnDestroy() {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}
}
